import React from 'react';
import DataQualityDeltaBadge from '../DataQualityDeltaBadge';

// The selected run's four headline numbers, styled as the Quality tab's Card (white,
// soft shadow, inset-left accent stripe). "Can't enrich" (exhausted) and "Still
// fillable" (actionable) reuse the real coverage vocabulary — no validity/malformed.
const fmt = (n) => Number(n || 0).toLocaleString('en-US');
const pct = (n) => `${Math.round(Number(n || 0))}%`;

function Card({ label, value, accent, children }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5" style={accent ? { boxShadow: `inset 3px 0 0 ${accent}` } : undefined}>
      <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
      <p className="text-2xl font-semibold text-gray-900 mt-2 tabular-nums">{value}</p>
      <div className="text-xs text-gray-400 mt-1">{children}</div>
    </div>
  );
}

export default function RunKpiRow({ overall, baseline }) {
  if (!overall) return null;
  const added = Number(overall.values_added || 0);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 my-6">
      <Card label="Completeness" value={pct(overall.after_pct)} accent="#00b39e">
        {baseline ? (
          'first snapshot'
        ) : (
          <span className="tabular-nums">
            {pct(overall.before_pct)} <span className="text-gray-300">→</span> {pct(overall.after_pct)}{' '}
            <DataQualityDeltaBadge value={overall.delta_pct} />
          </span>
        )}
      </Card>
      <Card label="Added this run" value={`${added >= 0 ? '+' : ''}${fmt(added)}`} accent="#1baf7a">
        values filled
      </Card>
      <Card label="Can't enrich" value={fmt(overall.exhausted)} accent="#e79797">
        searched, none verifiable
      </Card>
      <Card label="Still fillable" value={fmt(overall.actionable)} accent="#eda100">
        worth another run
      </Card>
    </div>
  );
}
